
import OcApiRequest from 'src/Api/OcApiRequest';

export type BioBubbleContact = {
    // id = ContactKey
    id: string;
    contactName: string;
    linkToProfile: string;
    jobTitle: string;
    company: string;
    location: string;
    ribbon: string | null;
    status: 'A' | 'D' | 'H' | 'P' | 'R';

    avatarUrl: string;
    canMessage: boolean;
    connectPermission: boolean;
    connectedToMe: boolean;
    
    requestTimeByMe: string | null;
    requestTimeByContact: string | null;
};

export const getBioBubbleContact = (contactKey: string): Promise<BioBubbleContact> => {
    return OcApiRequest.getPost<{ contact: BioBubbleContact }>('/shared/contactbio/getinfo', {
        contactKey
    }).then(({ contact }) => contact);
};

export const sendConnectRequest = (contactKey: string): Promise<string> => {
    return OcApiRequest.post<string>('/shared/friend/requestfriend', {
        FriendContactKey: contactKey
    });
};

export const resendConnectRequest = (contactKey: string): Promise<string> => {
    return OcApiRequest.post<string>('/shared/friend/resendfriendrequest', { 
        FriendContactKey: contactKey
    });
};

export const cancelConnectRequest = (contactKey: string): Promise<void> => {
    return OcApiRequest.post<void>('/shared/friend/cancelfriendrequest', {
        FriendContactKey: contactKey
    });
};

export const acceptConnectRequest = (contactKey: string): Promise<void> => {
    return OcApiRequest.post<void>('/shared/friend/acceptfriendrequest', {
        FriendContactKey: contactKey
    });
};

export const sendMessageToContact = (contactKey: string, subject: string, msg: string) => {
    return OcApiRequest.post<void>('/shared/message/sendmessagerequest', {
        RecipientContactKey: contactKey,
        Subject: subject,
        MessageText: msg
    });
};
